const WEEKDAY_MAP = { Mon: 'Lun', Tue: 'Mar', Wed: 'Mié', Thu: 'Jue', Fri: 'Vie', Sat: 'Sáb', Sun: 'Dom' };
const TZ = 'America/Santiago';

// El backend a veces emite timestamps SIN sufijo de zona (ej: "2026-04-29T14:40:00")
// porque PostgreSQL serializa columnas TIMESTAMP (sin TZ) sin marcar UTC dentro de
// jsonb_agg. Como Railway corre en UTC, esos valores son UTC reales — solo les
// falta el sufijo 'Z'. Si JS los parsea sin marker, los interpreta como hora local
// del navegador y termina mostrando hora desfasada.
function ensureUtcMarker(iso) {
  if (!iso || typeof iso !== 'string') return iso;
  if (/[Zz]$|[+-]\d{2}:?\d{2}$/.test(iso)) return iso;
  return iso + 'Z';
}

function getChilePartsFromDate(d) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ,
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).formatToParts(d);
  const get = (t) => parts.find(p => p.type === t)?.value || '';
  const hourRaw = get('hour');
  return {
    weekday: WEEKDAY_MAP[get('weekday')] || get('weekday'),
    year: get('year'),
    month: get('month'),
    day: get('day'),
    hour: hourRaw === '24' ? '00' : hourRaw,
    minute: get('minute')
  };
}

function formatDate(iso) {
  if (!iso) return '';
  try {
    const d = new Date(ensureUtcMarker(iso));
    if (isNaN(d)) return String(iso);
    const p = getChilePartsFromDate(d);
    return `${p.weekday} ${p.day}/${p.month}`;
  } catch {
    return String(iso);
  }
}

export function formatChange(change) {
  const { field, old: oldVal, new: newVal, agent } = change;
  const who = agent || 'Sistema';

  switch (field) {
    case 'next_followup_date':
      if (!oldVal && newVal) return `${who} agregó fecha de seguimiento: ${formatDate(newVal)}`;
      if (oldVal && !newVal) return `${who} quitó la fecha de seguimiento (era ${formatDate(oldVal)})`;
      return `${who} cambió la fecha de seguimiento: ${formatDate(oldVal)} → ${formatDate(newVal)}`;

    case 'hint':
      if (!oldVal && newVal) return `${who} agregó nota express: "${newVal}"`;
      if (oldVal && !newVal) return `${who} borró la nota express (era "${oldVal}")`;
      return `${who} cambió nota express: "${oldVal}" → "${newVal}"`;

    case 'bandera': {
      const oldStr = oldVal ? oldVal : 'sin bandera';
      const newStr = newVal ? newVal : 'sin bandera';
      return `${who} cambió FLAG: ${oldStr} → ${newStr}`;
    }

    case 'stage':
      if (newVal === 'bombilla_encendida') return `${who} encendió la bombilla 💡`;
      if (newVal === 'bombilla_apagada') return `${who} apagó la bombilla`;
      return `${who} cambió stage: ${oldVal} → ${newVal}`;

    case 'vendido':
      if (newVal === 'true') return `${who} marcó como VENDIDO`;
      if (newVal === 'false') return `${who} desmarcó vendido`;
      return `${who} cambió vendido: ${oldVal} → ${newVal}`;

    case 'venta_monto':
      return `${who} ${oldVal ? 'cambió' : 'agregó'} monto de venta: ${newVal}`;

    case 'agent_assigned':
      if (!oldVal && newVal) return `${who} asignó este prospecto a ${newVal}`;
      if (oldVal && !newVal) return `${who} desasignó este prospecto (era de ${oldVal})`;
      return `${who} reasignó: ${oldVal} → ${newVal}`;

    case 'icon_assigned':
      if (!oldVal && newVal) return `${who} asignó icono ${newVal}`;
      if (oldVal && !newVal) return `${who} quitó icono ${oldVal}`;
      return `${who} cambió icono: ${oldVal} → ${newVal}`;

    case 'note_added': {
      const txt = newVal || '';
      const preview = txt.slice(0, 80);
      return `${who} agregó nota: "${preview}${txt.length > 80 ? '...' : ''}"`;
    }

    default:
      return `${who} cambió ${field}: ${oldVal || '(vacío)'} → ${newVal || '(vacío)'}`;
  }
}

export function formatTimestamp(iso) {
  if (!iso) return '';
  try {
    const d = new Date(ensureUtcMarker(iso));
    if (isNaN(d)) return '';
    const p = getChilePartsFromDate(d);
    const today = getChilePartsFromDate(new Date());
    const sameDay = p.year === today.year && p.month === today.month && p.day === today.day;
    if (sameDay) return `${p.hour}:${p.minute}`;
    return `${p.weekday} ${p.day}/${p.month} ${p.hour}:${p.minute}`;
  } catch {
    return '';
  }
}
